module.exports = __webpack_public_path__ + "static/media/digital-hr-services.9b08ff88.png";